import axios from "axios";
import appconfig from "@/appconfig";
import router from "@/router";

const $axios = axios.create({
  baseURL: appconfig.apiendpoint
});

$axios.interceptors.request.use(
  config => {
    if (!config.headers.Authorization) {
      const token = localStorage.getItem(appconfig.token);
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

$axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status == 401) {
      location.href = appconfig.loginurl + "?returnurl=" + location.href;
    } else if (error.config.url.indexOf("users/password")) {
      return Promise.reject(error);
    } else {
      router.push({
        name: "ErrorView",
        params: { errorcode: error.response.status }
      });
    }

    return Promise.reject(error);
  }
);

export default $axios;
